export const transportaionTableHeader = [
  { field: 'sl_no', headerName: 'Serial No', width: 80 },
  { field: 'date', headerName: 'Date', width: 150 },
  { field: 'userName', headerName: 'Employee Name', width: 220 },
  {
    field: 'Mobile',
    headerName: 'Mobile',
    width: 220,
    renderCell: (params) => {
      const phoneNumber = params.value;
      const formattedNumber = `+91${phoneNumber}`;

      return (
        <span
          onClick={() => (window.location.href = `tel:${formattedNumber}`)}
          style={{ cursor: 'pointer', color: '#1976d2', fontWeight: 500 }}
        >
          📞 {phoneNumber}
        </span>
      );
    },
  },
  { field: 'timestamp', headerName: 'Booked Time', width: 220 },
  { field: 'slotName', headerName: 'Slot', width: 220 },
  // { field: 'department', headerName: 'Department', width: 220 },
  // { field: 'officeName', headerName: 'Office', width: 220 },

  // {
  //   field: 'remarks',
  //   headerName: 'Remarks',
  //   width: 250,
  //   renderCell: (params) => {
  //     return <ToolTip expand={params.row.remarks} content={params.row.remarks} />
  //   },
  // },
];
